import React, { useEffect, useState } from "react";
import { crmApi } from "../../lib/crmApi";
import { PageHead, BarList, SERVICE_CATEGORIES, label } from "./crmUi";

const RANGE_OPTIONS = [[7, "7 days"], [30, "30 days"], [90, "90 days"]];

function WhatsAppInterestSection() {
  const [days, setDays] = useState(30);
  const [w, setW] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    setW(null);
    crmApi.whatsappClicks(days).then(setW).catch((e) => setErr(e.message));
  }, [days]);

  const recentDays = (w?.by_date || []).slice(-14).reverse().filter((d) => d.clicks || d.form_leads);
  const catItems = (w?.by_category || []).map((i) => ({ ...i, key: label(SERVICE_CATEGORIES, i.key) }));

  return (
    <div className="mt-10" data-testid="crm-wa-interest">
      <div className="flex items-end justify-between gap-3 flex-wrap mb-4">
        <div>
          <p className="text-[10px] tracking-[0.32em] uppercase text-[#A6822F]">Website Behaviour</p>
          <h2 className="font-serif-display text-xl md:text-2xl text-[#1C110C]">WhatsApp Interest</h2>
        </div>
        <div className="flex gap-1.5">
          {RANGE_OPTIONS.map(([d, l]) => (
            <button
              key={d}
              type="button"
              data-testid={`crm-wa-range-${d}`}
              onClick={() => setDays(d)}
              className={`px-3 py-1.5 text-[9px] tracking-[0.18em] uppercase border ${
                days === d ? "bg-[#6E1F2C] text-white border-[#6E1F2C]" : "border-[#6E1F2C]/25 text-[#6E1F2C]"
              }`}
            >
              {l}
            </button>
          ))}
        </div>
      </div>
      {err && <p className="text-xs text-[#A3141A]">{err}</p>}
      {!w && !err && <p className="text-xs text-[#7A6B5F]">Loading…</p>}
      {w && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
            <div className="bg-white border border-[#6E1F2C]/10 p-5">
              <p className="font-serif-display text-3xl text-[#6E1F2C]" data-testid="crm-wa-clicks-today">{w.clicks_today}</p>
              <p className="text-[9px] tracking-[0.2em] uppercase text-[#7A6B5F] mt-1">WhatsApp clicks today</p>
            </div>
            <div className="bg-white border border-[#6E1F2C]/10 p-5">
              <p className="font-serif-display text-3xl text-[#1C110C]" data-testid="crm-wa-clicks-total">{w.total_clicks}</p>
              <p className="text-[9px] tracking-[0.2em] uppercase text-[#7A6B5F] mt-1">Clicks · last {w.range.days} days</p>
            </div>
            <div className="bg-white border border-[#6E1F2C]/10 p-5">
              <p className="font-serif-display text-3xl text-[#3F6E2C]">{w.total_form_leads}</p>
              <p className="text-[9px] tracking-[0.2em] uppercase text-[#7A6B5F] mt-1">Form leads · same period</p>
            </div>
            <div className="bg-white border border-[#6E1F2C]/10 p-5">
              <p className="font-serif-display text-3xl text-[#A6822F]">
                {w.total_clicks ? `${Math.round((w.total_form_leads / w.total_clicks) * 100)}%` : "—"}
              </p>
              <p className="text-[9px] tracking-[0.2em] uppercase text-[#7A6B5F] mt-1">Form leads / WA clicks</p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white border border-[#6E1F2C]/10 p-5">
              <p className="text-[10px] tracking-[0.26em] uppercase text-[#6E1F2C] mb-4">Top pages generating WhatsApp interest</p>
              <BarList items={(w.by_page || []).slice(0, 10)} testid="crm-wa-by-page" />
            </div>
            <div className="bg-white border border-[#6E1F2C]/10 p-5">
              <p className="text-[10px] tracking-[0.26em] uppercase text-[#6E1F2C] mb-4">Clicks by service category</p>
              <BarList items={catItems} testid="crm-wa-by-category" />
            </div>
            <div className="bg-white border border-[#6E1F2C]/10 p-5">
              <p className="text-[10px] tracking-[0.26em] uppercase text-[#6E1F2C] mb-4">Clicks by device</p>
              <BarList items={w.by_device || []} testid="crm-wa-by-device" />
            </div>
            <div className="bg-white border border-[#6E1F2C]/10 p-5">
              <p className="text-[10px] tracking-[0.26em] uppercase text-[#6E1F2C] mb-4">Clicks vs form leads by day (recent)</p>
              {recentDays.length === 0 ? (
                <p className="text-xs text-[#7A6B5F] italic">No activity in this range yet.</p>
              ) : (
                <table className="w-full text-[12px]" data-testid="crm-wa-by-date">
                  <thead>
                    <tr className="text-left text-[9px] tracking-[0.16em] uppercase text-[#7A6B5F] border-b border-[#6E1F2C]/15">
                      <th className="py-1.5">Date</th>
                      <th className="py-1.5 text-right">WA clicks</th>
                      <th className="py-1.5 text-right">Form leads</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentDays.map((d) => (
                      <tr key={d.date} className="border-b border-[#6E1F2C]/8">
                        <td className="py-1.5 text-[#3E2A22]">{d.date}</td>
                        <td className="py-1.5 text-right text-[#6E1F2C] font-medium">{d.clicks}</td>
                        <td className="py-1.5 text-right text-[#3F6E2C] font-medium">{d.form_leads}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default function ReportsPage() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    crmApi.dashboard().then(setD).catch((e) => setErr(e.message));
  }, []);

  if (err) return <p className="text-xs text-[#A3141A]">{err}</p>;
  if (!d) return <p className="text-xs text-[#7A6B5F]">Loading…</p>;

  const totalClosed = d.won + d.lost;
  const winRate = totalClosed ? Math.round((d.won / totalClosed) * 100) : null;

  return (
    <div data-testid="crm-reports-page">
      <PageHead eyebrow="Performance" title="Reports" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
        <div className="bg-white border border-[#6E1F2C]/10 p-5">
          <p className="font-serif-display text-3xl text-[#3F6E2C]">{d.won}</p>
          <p className="text-[9px] tracking-[0.2em] uppercase text-[#7A6B5F] mt-1">Won</p>
        </div>
        <div className="bg-white border border-[#6E1F2C]/10 p-5">
          <p className="font-serif-display text-3xl text-[#7A6B5F]">{d.lost}</p>
          <p className="text-[9px] tracking-[0.2em] uppercase text-[#7A6B5F] mt-1">Lost</p>
        </div>
        <div className="bg-white border border-[#6E1F2C]/10 p-5">
          <p className="font-serif-display text-3xl text-[#6E1F2C]" data-testid="crm-report-winrate">{winRate != null ? `${winRate}%` : "—"}</p>
          <p className="text-[9px] tracking-[0.2em] uppercase text-[#7A6B5F] mt-1">Win rate</p>
        </div>
        <div className="bg-white border border-[#6E1F2C]/10 p-5">
          <p className="font-serif-display text-3xl text-[#A3141A]">{d.hot_leads}</p>
          <p className="text-[9px] tracking-[0.2em] uppercase text-[#7A6B5F] mt-1">Hot in pipeline</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white border border-[#6E1F2C]/10 p-5">
          <p className="text-[10px] tracking-[0.26em] uppercase text-[#6E1F2C] mb-4">Lead source performance</p>
          <BarList items={d.by_source} testid="crm-report-source" />
        </div>
        <div className="bg-white border border-[#6E1F2C]/10 p-5">
          <p className="text-[10px] tracking-[0.26em] uppercase text-[#6E1F2C] mb-4">Leads by service category</p>
          <BarList items={d.by_category} testid="crm-report-category" />
        </div>
        {d.by_salesperson?.length > 0 && (
          <div className="bg-white border border-[#6E1F2C]/10 p-5">
            <p className="text-[10px] tracking-[0.26em] uppercase text-[#6E1F2C] mb-4">Leads by salesperson</p>
            <BarList items={d.by_salesperson} testid="crm-report-salesperson" />
          </div>
        )}
        <div className="bg-white border border-[#6E1F2C]/10 p-5">
          <p className="text-[10px] tracking-[0.26em] uppercase text-[#6E1F2C] mb-4">Pipeline by status</p>
          <BarList items={d.by_status} testid="crm-report-status" />
        </div>
      </div>
      <WhatsAppInterestSection />
    </div>
  );
}
